import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: "rotate(180deg)",
      transition: ".3s",
    }}
    viewBox="0 0 1440 320"
    {...props}
  >
    <defs>
      <linearGradient id="a" x1={0} x2={0} y1={1} y2={0}>
        <stop offset="0%" stopColor="rgba(243, 106, 62, 1)" />
        <stop offset="100%" stopColor="rgba(255, 179, 11, 1)" />
      </linearGradient>
    </defs>
    <path
      fill="url(#a)"
      d="m0 0 21.8 10.7C43.6 21 87 43 131 80c43.5 37 87 91 131 128 43.5 37 87 59 131 26.7C436.4 203 480 117 524 101.3c43.3-16.3 87 37.7 131 48 43.2 10.7 87-21.3 130-16 44.1 5.7 88 47.7 131 69.4 44 21.3 88 21.3 131 32 43.9 10.3 88 32.3 131 5.3 43.8-27 87-101 131-122.7 43.7-21.3 87 10.7 131 5.4 43.6-5.7 87-47.7 131-26.7 43.5 21 87 107 131 128 43.5 21 87-21 131-58.7 43.4-37.3 87-69.3 131-48 43.3 21.7 87 95.7 131 133.4 43.2 37.3 87 37.3 130 37.3 44.1 0 88 0 131-48 44-48 88-144 131-186.7 43.9-42.3 88-32.3 131 5.4C2661.8 96 2705 160 2749 192c43.7 32 87 32 131 32 43.6 0 87 0 131-26.7 43.5-26.3 87-80.3 109-106.6l21.8-26.7v256H0Z"
      style={{
        transform: "translate(0,0)",
        opacity: 1,
      }}
    />
    <defs>
      <linearGradient id="b" x1={0} x2={0} y1={1} y2={0}>
        <stop offset="0%" stopColor="rgba(243, 230.327, 62, 1)" />
        <stop offset="100%" stopColor="rgba(255, 179, 11, 1)" />
      </linearGradient>
    </defs>
    <path
      fill="url(#b)"
      d="M0 64h21.8C43.6 64 87 64 131 96c43.5 32 87 96 131 101.3 43.5 5.7 87-48.3 131-42.6 43.4 5.3 87 69.3 131 58.6 43.3-10.3 87-96.3 131-96 43.2-.3 87 85.7 130 85.4 44.1.3 88-85.7 131-101.4 44-16.3 88 37.7 131 48 43.9 10.7 88-21.3 131-53.3 43.8-32 87-64 131-58.7 43.7 5.7 87 47.7 131 64 43.6 15.7 87 5.7 131 10.7 43.5 5 87 27 131 16 43.5-11 87-53 131-42.7 43.4 10.7 87 74.7 131 80 43.3 5.7 87-48.3 131-80C2138.2 53 2182 43 2225 64c44.1 21 88 75 131 117.3 44 42.7 88 74.7 131 85.4 43.9 10.3 88 .3 131-42.7 43.8-43 87-117 131-154.7 43.7-37.3 87-37.3 131-32 43.6 5.7 87 15.7 131 37.4 43.5 21.3 87 53.3 109 69.3l21.8 16v160H0Z"
      style={{
        transform: "translate(0,50px)",
        opacity: 0.9,
      }}
    />
    <defs>
      <linearGradient id="c" x1={0} x2={0} y1={1} y2={0}>
        <stop offset="0%" stopColor="rgba(243, 106, 62, 1)" />
        <stop offset="100%" stopColor="rgba(11, 255, 245.906, 1)" />
      </linearGradient>
    </defs>
    <path
      fill="url(#c)"
      d="m0 32 21.8 5.3C43.6 43 87 53 131 80c43.5 27 87 69 131 106.7C305.5 224 349 256 393 240c43.4-16 87-80 131-117.3C567.3 85 611 75 655 69.3c43.2-5.3 87-5.3 130-10.6 44.1-5.7 88-15.7 131 0 44 16.3 88 58.3 131 85.3 43.9 27 88 37 131 42.7 43.8 5.3 87 5.3 131-10.7 43.7-16 87-48 131-42.7 43.6 5.7 87 47.7 131 42.7 43.5-5 87-59 131-69.3 43.5-10.7 87 21.3 131 26.6 43.4 5.7 87-16.3 131-37.3 43.3-21 87-43 131-48 43.2-5 87 5 130 26.7 44.1 21.3 88 53.3 131 74.6 44 21.7 88 31.7 131 21.4 43.9-10.7 88-42.7 131-53.4 43.8-10.3 87-.3 131 21.4 43.7 21.3 87 53.3 131 42.6 43.6-10.3 87-64.3 131-96 43.5-32.3 87-42.3 109-48l21.8-5.3v288H0Z"
      style={{
        transform: "translate(0,100px)",
        opacity: 0.8,
      }}
    />
  </svg>
)
export default SvgComponent
